import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, routerLocationShape } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';

import { IMG_ICON_CHEVRON_LEFT } from '../img';

var styles = void 0;

var addReverseState = function addReverseState(location) {
  if (typeof location === 'string') {
    return {
      pathname: location,
      state: { reverse: true }
    };
  }

  return Object.assign({}, location, {
    state: Object.assign({}, location.state || {}, {
      reverse: true
    })
  });
};

var Back = function Back(_ref) {
  var location = _ref.location;
  return React.createElement(
    NavLink,
    { to: addReverseState(location), className: css(styles.link), activeClassName: css(styles.link) },
    React.createElement(Icon, { src: IMG_ICON_CHEVRON_LEFT, stroke: TSS_DARK_BLUE, className: css(styles.chevron) }),
    React.createElement(
      'span',
      { className: css(styles.text) },
      React.createElement(FormattedMessage, { id: 'label.back' })
    )
  );
};

Back.propTypes = {
  location: routerLocationShape.isRequired
};

Back.defaultProps = {};

styles = StyleSheet.create({
  link: {
    textDecoration: 'none',
    color: TSS_DARK_BLUE,
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    padding: '2.4rem 2.1rem',
    borderBottom: '2px solid ' + TSS_DARK_BLUE(0.05)
  },

  text: {
    position: 'relative',
    top: 1
  },

  chevron: {
    margin: '0 1.2rem 0 0'
  }
});

export default Back;